document.addEventListener('DOMContentLoaded', function() {
  var lightbox = document.getElementById('cvLightbox');
  if (!lightbox) return;

  // 元素
  var imgEl = lightbox.querySelector('.cv-lightbox__img');
  var btnClose = lightbox.querySelector('.cv-lightbox__close');
  var btnPrev = lightbox.querySelector(".cv-lightbox__prev");
  var btnNext = lightbox.querySelector(".cv-lightbox__next");
  // 可选：说明
  // var captionEl = lightbox.querySelector('.cv-lightbox__caption');

  if (!imgEl ) {
  console.warn('imgEl elements missing');
  return;
}
 if (!btnClose ) {
  console.warn('Lightbox elements missing');
  return;
}
 if ( !btnPrev ) {
  console.warn('btnPrev elements missing');
  return;
}
 if (!btnNext) {
  console.warn('Lightbox elements missing');
  return;
}


  // 从页面收集所有可预览项（支持后续“加载更多”——事件委托）
  function getItems() {
    return Array.from(document.querySelectorAll('a[data-lightbox-item]')).map(function(a, idx) {
      return {
        link: a,
        href: a.getAttribute('href'),
        alt: (a.querySelector('img') && a.querySelector('img').getAttribute('alt')) || '',
        // caption: a.getAttribute('data-caption') || '',
        index: idx
      };
    });
  }

  var items = getItems();
  var current = -1; // 当前索引
  var lastActive = null;

  function openAt(index) {
    items = getItems(); // 重新获取，兼容动态变化
    if (!items.length) return;

    // 索引环绕
    if (index < 0) index = items.length - 1;
    if (index >= items.length) index = 0;
    current = index;

    var it = items[current];
    // 显示
    imgEl.src = it.href;
    imgEl.alt = it.alt || '';
    // if (captionEl) captionEl.textContent = it.caption;

    if (!lightbox.classList.contains('is-active')) {
      lastActive = document.activeElement;
      lightbox.classList.add('is-active');
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden'; // 锁背景滚动
    }

    // 导航按钮在一张图时可隐藏
    var multi = items.length > 1;
    btnPrev.style.display = multi ? '' : 'none';
    btnNext.style.display = multi ? '' : 'none';

    // 将焦点给关闭按钮，便于无障碍
    btnClose.focus();
  }

  function closeLightbox() {
    if (!lightbox.classList.contains('is-active')) return;
    lightbox.classList.remove('is-active');
    lightbox.setAttribute('aria-hidden', 'true');
    imgEl.src = '';
    document.documentElement.style.overflow = '';
    if (lastActive && typeof lastActive.focus === 'function') {
      lastActive.focus();
    }
  }

  function showPrev() { openAt(current - 1); }
  function showNext() { openAt(current + 1); }

  // 打开：委托监听所有 data-lightbox-item
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[data-lightbox-item]');
    if (!link) return;
    e.preventDefault();
    // 找到该链接在 items 中的索引
    items = getItems();
    var idx = items.findIndex(function(it) { return it.link === link; });
    if (idx === -1) idx = 0;
    openAt(idx);
  });

  // 关闭按钮
  btnClose.addEventListener('click', closeLightbox);

  // 点击遮罩空白关闭（点击图片本身不关闭）
  lightbox.addEventListener('click', function(e) {
    if (e.target === lightbox) closeLightbox();
  });

  // 导航
  btnPrev.addEventListener('click', function(e) { e.stopPropagation(); showPrev(); });
  btnNext.addEventListener('click', function(e) { e.stopPropagation(); showNext(); });

  // 键盘支持：Esc 关闭，左右切换
  document.addEventListener('keydown', function(e) {
    if (!lightbox.classList.contains('is-active')) return;
    if (e.key === 'Escape') {
      closeLightbox();
    } else if (e.key === 'ArrowLeft') {
      showPrev();
    } else if (e.key === 'ArrowRight') {
      showNext();
    }
  });

  // 可选：滑动手势（移动端），轻量实现
  var touchStartX = 0;
  lightbox.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].clientX;
  }, { passive: true });
  lightbox.addEventListener('touchend', function(e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > 40) {
      if (dx > 0) showPrev(); else showNext();
    }
  });
});
